/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  
  
class SidebarAccordion {
  constructor(rootSelector) {
    this.root = document.querySelector(rootSelector);
    if (!this.root) return;

    this.bind();
    this.openFirst();
  }

  bind() {
    this.root.addEventListener('click', e => {
      const btn = e.target.closest('.sidebar_accordion_title');
      if (!btn) return;

      e.preventDefault();
      const accordion = btn.closest('.sidebar_accordion');
      this.toggle(accordion);
    });
  }

  toggle(accordion) {
    const isOpen = accordion.classList.contains('is-open');

    this.closeSiblings(accordion);

    requestAnimationFrame(() => {
      isOpen ? this.close(accordion) : this.open(accordion);
    });
  }

  open(accordion) {
    const content = accordion.querySelector(':scope > .sidebar_accordion_content');
    if (!content) return;

    accordion.classList.add('is-open');
    accordion.querySelector(':scope > .sidebar_accordion_title')
      .setAttribute('aria-expanded', 'true');

    content.style.visibility = 'visible';

    // Set explicit height for animation
    content.style.height = content.scrollHeight + 'px';

    // After animation → release to auto
    content.addEventListener('transitionend', function handler(e) {
      if (e.propertyName !== 'height') return;
      content.style.height = 'auto';
      content.removeEventListener('transitionend', handler);
    });

    this.syncParents(accordion);
  }

  close(accordion) {
    const content = accordion.querySelector(':scope > .sidebar_accordion_content');
    if (!content) return;

    accordion.classList.remove('is-open');
    accordion.querySelector(':scope > .sidebar_accordion_title')
      .setAttribute('aria-expanded', 'false');

    // Close children first
    accordion.querySelectorAll(':scope .sidebar_accordion.is-open')
      .forEach(child => this.close(child));

    // From auto → fixed height → 0
    content.style.height = content.scrollHeight + 'px';

    requestAnimationFrame(() => {
      content.style.height = '0';
    });

    content.addEventListener('transitionend', function handler(e) {
      if (e.propertyName !== 'height') return;
      content.style.visibility = 'hidden';
      content.removeEventListener('transitionend', handler);
    });

    this.syncParents(accordion);
  }

  closeSiblings(accordion) {
    const siblings = accordion
      .closest('ul')
      ?.querySelectorAll(':scope > li > .sidebar_accordion');

    siblings?.forEach(sib => {
      if (sib !== accordion && sib.classList.contains('is-open')) {
        this.close(sib);
      }
    });
  }

  syncParents(accordion) {
    let parent = accordion.parentElement.closest('.sidebar_accordion');

    while (parent) {
      const content = parent.querySelector(':scope > .sidebar_accordion_content');
      if (content && parent.classList.contains('is-open')) {
        // Temporarily fix height so browser recalculates correctly
        content.style.height = content.scrollHeight + 'px';

        content.addEventListener('transitionend', function handler(e) {
          if (e.propertyName !== 'height') return;
          content.style.height = 'auto';
          content.removeEventListener('transitionend', handler);
        });
      }
      parent = parent.parentElement.closest('.sidebar_accordion');
    }
  }

  openFirst() {
    const first = this.root.querySelector(
      '.sidebar_menu > ul > li > .sidebar_accordion'
    );
    if (first) this.open(first);
  }

  reset() {
    this.root.querySelectorAll('.sidebar_accordion.is-open')
      .forEach(acc => this.close(acc));
    this.openFirst();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const sidebar = new SidebarAccordion('.sidebar-navigation');

  document.querySelectorAll('.drawer__close, .drawer__underlay').forEach(el => {
      el.addEventListener('click', () => sidebar.reset());
    });
});

class RebuyPredictiveSearch {
  constructor() {
    this.containers = document.querySelectorAll(".search_recommendations .rebuy_recommendation");
    this.API_KEY = "704d74f273b5ca16c1ce8cc167bd63bb85c5c191";
    this.SECTION_HANDLE = "search-product-item";
  }

  async init() {
    if (!this.containers.length) return;

    const products = await this.fetchProducts();
    if (!products.length) return;

    const productUrls = products.map(p => `/products/${p.handle}`);
    await this.renderProducts(productUrls);
  }

  async fetchProducts() {
    try {
      const params = new URLSearchParams({ key: this.API_KEY, limit: 10 });
      const res = await fetch(`https://rebuyengine.com/api/v1/products/trending_products?${params}`);
      const data = await res.json();
      console.log("Rebuy trending products:", data);
      return data.data || [];
    } catch (e) {
      console.error("Rebuy API error:", e);
      return [];
    }
  }

  async renderProducts(productUrls) {
    this.containers.forEach(async container => {
      container.innerHTML = "";
      let count = 0;

      for (let url of productUrls) {
        if (count >= 4) break; // stop after 4 products

        try {
          const sectionUrl = `${url}?section_id=${this.SECTION_HANDLE}`;
          const res = await fetch(sectionUrl);
          const htmlText = await res.text();

          const parser = new DOMParser();
          const doc = parser.parseFromString(htmlText, "text/html");

          const productCard = doc.querySelector(".predictive-search__grid-item");
          if (productCard) {
            container.appendChild(productCard);
            if (!productCard.classList.contains("hidden") && productCard.offsetParent !== null) {
              count++;
            }
          }
        } catch (e) {
          console.error("Error rendering product from Shopify:", e);
        }
      }
    });
  }
}

// INIT
document.addEventListener("DOMContentLoaded", () => {
  new RebuyPredictiveSearch().init();
});

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
